import { useQuery } from "@tanstack/react-query";
import { fetchVehicleById } from "../../api/vehicle/vehicleService";

export const useVehicleDetails = (vehId) => {
    const isValidId = Number.isInteger(vehId) && vehId > 0;

    return useQuery({
        queryKey: ["vehicle", vehId],
        queryFn: async () => {
            if (!isValidId) {
                throw new Error("ID del vehiculo inválido. La consulta no debería haberse activado.");
            }
            return fetchVehicleById(vehId);
        },
        enabled: isValidId,

        staleTime: 1000 * 60 * 5,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,        
        
        retry: (failureCount, error) => {
            if (error.message && error.message.includes('Missing queryFn')) {
                return false;
            }
            return failureCount < 3;
        },
        onSettled: (data, error, status) => {
            if (data && error && error.message && error.message.includes('Missing queryFn')) {
                console.warn("useComponentDetails: Ignored a 'Missing queryFn' error because data was successfully retrieved.");                
            }
        },
    });
};